import * as Glide from "@glidejs/glide";
import { useEffect, useRef } from "react";
import type { useGlideProps } from "./types";

const defaultSettings: Omit<useGlideProps, "id" | "ref"> = {
  type: "carousel",
  perView: 1,
  gap: 0,
  peek: {
    before: 0,
    after: 0,
  },
  breakpoints: {
    500: {
      animationDuration: 300,
      dragThreshold: false,
      swipeThreshold: 40,
    },
  },
};

export const useGlide = ({
  ref,
  id,
  perView = defaultSettings.perView,
  gap = defaultSettings.gap,
  peek = defaultSettings.peek,
  type = defaultSettings.type,
  breakpoints = defaultSettings.breakpoints,
}: useGlideProps) => {
  const glideInstance = useRef<Glide | null>();

  useEffect(() => {
    if (ref && id) {
      glideInstance.current = new Glide.default(`#${id}`, {
        type,
        perView,
        gap,
        animationTimingFunc: "ease-out",
        waitForTransition: false,
        throttle: 0,
        swipeThreshold: 0,
        dragThreshold: false,
        keyboard: false, // There is a bug with Glide keyboard navigation where all glide instances are affected by the same keyboard event
        animationDuration: 500,
        startAt: 0,
        peek: peek,
        breakpoints: breakpoints ? breakpoints : defaultSettings.breakpoints,
      });

      glideInstance.current.mount();
    }
  }, [ref, id, perView, gap, peek, type, breakpoints]);

  return {
    glideInstance,
  };
};
